import { render, staticRenderFns } from "./SelfEdit.vue?vue&type=template&id=f6577082&scoped=true&"
import script from "./SelfEdit.vue?vue&type=script&lang=js&"
export * from "./SelfEdit.vue?vue&type=script&lang=js&"
import style0 from "./SelfEdit.vue?vue&type=style&index=0&id=f6577082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6577082",
  null
  
)

export default component.exports